import { Book, ChatBubble } from "@mui/icons-material";
import { Chip } from "@mui/material";
import React from "react";
import { PageContainer } from "../components/Common/PageContainer";
import { DashboardLayout } from "../components/DashboardLayout/DashboardLayout";
import { FeatureCards } from "../components/FeatureCards";

export const SiriusHomePage: React.FC = () => {
  const features = [
    {
      title: "Discuter avec mes agents",
      path: "/sirius/bots",
      icon: <ChatBubble sx={{ fontSize: 40 }} />,
    },
    {
      title: "Ajouter de la documentation",
      path: "/sirius/connectors",
      icon: <Book sx={{ fontSize: 40 }} />,
      children: (
        <Chip
          label="Coming Soon"
          color="secondary"
          size="small"
          sx={{ mt: 1 }}
        />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}>
        <FeatureCards features={features} />
      </PageContainer>
    </DashboardLayout>
  );
};
